import React, { useEffect, useState } from "react";
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, Tooltip, Legend } from "recharts";
import { Spinner } from 'react-bootstrap';

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div className="custom-tooltip">
                <div>{payload[0].payload.carrierName} ({label})</div>
                <div className="tooltipTitle_blue">Bill Count : {payload[0].value} </div>
                <div className="tooltipTitle_yellow">Amount : {parseFloat(payload[1].value).toFixed(2)}</div>
            </div>
        );
    }

    return null;
};

const CustomSpinner = () => {
    return (
        <div className='col-md-6 col-xs-12 col-lg-4 col-sm-12'>
            <div className="card mb-2">
                <MySpinner />
                <div className="card-header blue-heading">
                    Top Transportation Providers by Bill Count
                </div>
                <div className="card-body search-form">
                    <div style={{ width: '100%' }} className='set-height'></div>
                </div>
            </div>
        </div>
    )
}

const RenderChart = ({ data }) => {
    return (
        <>
            <div className='col-md-6 col-xs-12 col-lg-4 col-sm-12'>
                <div className="card mb-2">
                    <div className="card-header blue-heading">
                        Top Transportation Providers by Bill Count
                    </div>
                    <div className="card-body search-form">
                        <div style={{ width: '100%' }} className='set-height'>
                            <ResponsiveContainer>
                                <BarChart data={data}
                                    margin={{
                                        top: 10,
                                        right: 30,
                                        left: 0,
                                        bottom: 0,
                                    }}>
                                    <XAxis dataKey="carrierScacCode" />
                                    <YAxis dataKey="billCount" />
                                    <Tooltip content={<CustomTooltip />} />
                                    <Legend />
                                    <Bar dataKey="billCount" name="Bill Count" fill="#1f79a4" />
                                    <Bar dataKey="billAmount" name="Amount" fill="#eac205" />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const MySpinner = () => {
    return (
        <Spinner className='spinner-border spinner-border-chart' />
    )
}

export default function TopProviderByBillCount({ data, loading }) {
    if (loading) {
        return <CustomSpinner />
    }

    return <RenderChart data={data} />
}